import type { KeycloakUserDto } from '@src/api';

import type { Route } from '../types';

interface IFilterRoutes<T> {
  routes: T[];
  user?: KeycloakUserDto | null;
}

// Фильтрация роутов по пермишинам
export const filterRoutes = <T extends Route>({ routes, user }: IFilterRoutes<T>): T[] => {
  if (!user || !user.permissions?.length) return [];

  const permNameArray = user.permissions?.map((pr) => ({ resourceName: pr.resourceName, scopes: pr.scopes }));

  return routes
    .filter((rt) => {
      if (rt.resourceName) {
        const scopes = permNameArray?.find((el) =>
          Array.isArray(rt.resourceName)
            ? rt.resourceName.includes(el.resourceName)
            : rt.resourceName === el.resourceName,
        )?.scopes;
        return scopes?.length ? scopes.includes('VIEW') : false;
      }
      return true;
    })
    .map((route) => {
      if (route.routes) {
        return {
          ...route,
          routes: filterRoutes({ routes: route.routes, user }),
        };
      } else return route;
    })
    .filter((el) => (el.routes ? el.routes.length : true));
};

export const customizeRoutes = ({
  routes,
  setCustomRoutes,
}: {
  routes: Route[];
  setCustomRoutes: (route: Route) => Route;
}): Route[] =>
  routes.map((route) => {
    if (route.routes?.length) {
      const newRoute = setCustomRoutes(route);
      return { ...newRoute, routes: customizeRoutes({ routes: newRoute.routes || [], setCustomRoutes }) };
    }
    return setCustomRoutes(route);
  });
